export const ssnMask = [
    [/\d/],
    [/\d/],
    [/\d/],
    [/\d/],
    [/\d/],
    [/\d/],
    [/\d/],
    [/\d/],
    [/\d/],
];
/**
 * Process a regex mask character
 */
function processRegexMaskChar(maskChar, valueChar, unmaskedValueChar, obfuscationCharacter) {
    const shouldObfuscateChar = Array.isArray(maskChar);
    const maskCharRegex = Array.isArray(maskChar) ? maskChar[0] : maskChar;
    const matchRegex = RegExp(maskCharRegex).test(valueChar);
    if (matchRegex) {
        return {
            masked: valueChar,
            obfuscated: shouldObfuscateChar ? obfuscationCharacter : valueChar,
            unmasked: unmaskedValueChar,
            matched: true,
        };
    }
    return { masked: "", obfuscated: "", unmasked: "", matched: false };
}
/**
 * Process a fixed mask character
 */
function processFixedMaskChar(maskChar) {
    return {
        masked: maskChar,
        obfuscated: maskChar,
    };
}
/**
 * Process a single mask character against the current value character
 */
function processMaskChar(maskChar, valueChar, unmaskedValueChar, obfuscationCharacter) {
    // Value equals mask: add to masked result and advance on both mask and value indexes
    if (maskChar === valueChar) {
        return {
            masked: maskChar,
            obfuscated: maskChar,
            unmasked: "",
            advanceMask: true,
            advanceValue: true,
        };
    }
    // It's a regex maskChar: validate the value within the regex
    if (typeof maskChar === "object") {
        const result = processRegexMaskChar(maskChar, valueChar, unmaskedValueChar, obfuscationCharacter);
        return {
            ...result,
            advanceMask: result.matched,
            advanceValue: true,
        };
    }
    // It's a fixed maskChar: add to maskedResult and advance on mask index
    const fixedResult = processFixedMaskChar(maskChar);
    return {
        ...fixedResult,
        unmasked: "",
        advanceMask: true,
        advanceValue: false,
    };
}
export default function formatWithMask(props) {
    const { text, mask, obfuscationCharacter = "*" } = props;
    // Make sure it'll not break with null or undefined inputs
    if (!text) {
        return { masked: "", unmasked: "", obfuscated: "" };
    }
    if (!mask) {
        return {
            masked: text ?? "",
            unmasked: text ?? "",
            obfuscated: text ?? "",
        };
    }
    const maskArray = typeof mask === "function" ? mask(text) : mask;
    let masked = "";
    let obfuscated = "";
    let unmasked = "";
    let maskCharIndex = 0;
    let valueCharIndex = 0;
    while (maskCharIndex < maskArray.length && valueCharIndex < text.length) {
        const maskChar = maskArray[maskCharIndex];
        const valueChar = text[valueCharIndex];
        const unmaskedValueChar = text[valueCharIndex];
        const result = processMaskChar(maskChar, valueChar, unmaskedValueChar, obfuscationCharacter);
        masked += result.masked;
        obfuscated += result.obfuscated;
        unmasked += result.unmasked;
        if (result.advanceMask) {
            maskCharIndex += 1;
        }
        if (result.advanceValue) {
            valueCharIndex += 1;
        }
    }
    return { masked, unmasked, obfuscated };
}
//# sourceMappingURL=formatWithMask.js.map